import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  feedbackDetails: {}
};

export const SnackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    setFeedbackDetails: (state, action) => {
      state.feedbackDetails = action.payload;
    }
  }
});

export const { setFeedbackDetails } = SnackbarSlice.actions;
export default SnackbarSlice.reducer;
